import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Award } from "lucide-react";
import { VIPCard } from "@/components/CarnetVIP";
import { API } from "@/components/App";

/**
 * Página pública del carnet VIP. Es el enlace que recibe el cliente por WhatsApp.
 * No requiere sesión. Muestra la tarjeta y permite guardarla como imagen.
 */
export default function CarnetPublico() {
  const { serie } = useParams();
  const [carnet, setCarnet] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/vip/publico/${serie}`)
      .then(r => setCarnet(r.data))
      .catch(() => setError('Este carnet no existe o ya no está activo.'));
  }, [serie]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-slate-100 flex flex-col items-center px-4 py-8">
      <div className="flex items-center gap-3 mb-6">
        <img src="/logo-farmavida2.jpg" alt="Farmavida" className="w-11 h-11 rounded-full shadow" />
        <div>
          <p className="text-base font-bold text-slate-800 leading-tight">Farmavida</p>
          <p className="text-xs text-slate-500">Programa Clientes VIP</p>
        </div>
      </div>

      {error ? (
        <div className="bg-white rounded-xl shadow p-6 text-center text-slate-600 max-w-sm">
          <Award className="w-10 h-10 text-slate-300 mx-auto mb-3" />
          {error}
        </div>
      ) : !carnet ? (
        <p className="text-slate-400 text-sm">Cargando tu carnet…</p>
      ) : (
        <>
          <h1 className="text-lg font-bold text-slate-800 text-center mb-1">
            ¡Bienvenido(a), {carnet.nombre_completo}!
          </h1>
          <p className="text-sm text-slate-500 text-center max-w-sm mb-6">
            Este es tu carnet digital. Guárdalo en tu teléfono y preséntalo en caja
            junto con tu cédula para disfrutar tu {carnet.porcentaje_descuento}% de descuento.
          </p>
          <div className="max-w-full overflow-x-auto">
            <VIPCard carnet={carnet} showPrint={false} showDownload showWhatsApp={false} />
          </div>
          <p className="text-xs text-slate-400 text-center mt-8">
            Válido en todas las sedes Farmavida · Gracias por tu preferencia 💊
          </p>
        </>
      )}
    </div>
  );
}
